import { makeStyles } from "@mui/styles";
import { primary_color_1, text_color_light } from "../../themes/colors";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  message_card: {
    borderRadius: "3px",
  },
  message_head: {
    padding: "10px",
    backgroundColor: primary_color_1,
    color: text_color_light,
    fontWeight: "bold",
    fontFamily: "sans-serif",
  },
  message_body: {
    padding: "10px",
    fontFamily: "system-ui",
    minHeight: "50px",
    color: "#6f6f6f",
  },
  message_buttons: {
    justifyContent: "end",
    padding: "10px",
    display: "flex",
    flexDirection: "row",
    gap: 10,
  },
}));

export default useStyles;
